// extracted by mini-css-extract-plugin
export default {"w-full":"Chart_w-full__pm913","chart":"Chart_chart__6m7Vl"};